import { createContext, useContext, useMemo, useState } from 'react';
import { Tooltip as KendoTooltip, TooltipProps } from '@progress/kendo-react-tooltip';
import styles from './Tooltip.module.scss';

export interface TooltipInterface {
    onBlur: (event: any) => void,
    onKeyDown: (event: any) => void,
    onMouseDown: (event: any) => void,
    onMouseOver: (event: any) => void,
    onMouseOut: (event: any) => void
};

const defaultContext = {
    onBlur: () => {},
    onKeyDown: () => {},
    onMouseDown: () => {},
    onMouseOver: () => {},
    onMouseOut: () => {}
};

const TooltipContext = createContext<TooltipInterface>(defaultContext);

type TooltipState = {
    open?: boolean,
    openDelay?: number,
    target?: any
};

export const Tooltip = ({ children, ...rest }: TooltipProps) => {
    const [state, setState] = useState<TooltipState>({});
    const context: TooltipInterface = useMemo(() => ({
       
        onBlur: (event: Event) => {
            const target = event.target;
            setState((prev) => (prev.target === target ? { open: false } : prev));
        },

        onKeyDown: (event: KeyboardEvent) => {
            if (event.code === 'Enter') {
                const target = event.target;
                setState((prev) => ({
                    open: prev.target === target ? !prev.open : true,
                    openDelay: 0,
                    target
                }));
            } else if (event.code === 'Escape') {
                setState({ open: false });
            }
        },
        
        onMouseDown: (event: MouseEvent) => {
            const target = event.target;
            setState((prev) => ({
                open: prev.target === target ? !prev.open : true,
                openDelay: 0,
                target
            }));
        },
        
        onMouseOut: (event: MouseEvent) => {
            const target = event.target;
            setState((prev) => (prev.target === target ? { open: false } : prev));
        },
    
        onMouseOver: (event: MouseEvent) => {
            const target = event.target;
            setState((prev) => ({                
                open: prev.target === target ? prev.open : true,
                openDelay: 200,
                target
            }));
        }
    
    }), []);
    
    return (
        <KendoTooltip
            anchorElement="target"
            open={state.open}
            openDelay={state.openDelay}
            parentTitle={true}
            targetElement={state.target}
            tooltipClassName={styles.tooltip}
            {...rest}
        >
            <TooltipContext.Provider value={context}>
                {children}
            </TooltipContext.Provider>
        </KendoTooltip>
    );
};

export const useTooltipContext = () => useContext(TooltipContext);